import React from 'react';
import {Button, ButtonGroupProps} from '@mantine/core';

export const EtroButtonGroup: React.FC<ButtonGroupProps> = props => {
  return <Button.Group {...props} />;
};
